import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CallsConfigurationApiService {

  constructor(private http: HttpClient) {}

  private readonly callsConfigurationUrl: string = 'configuration/calls';

  public getCallsConfiguration(): Observable<any> {
    return this.http.get(this.callsConfigurationUrl);
  }

  public editCallsConfiguration(callsConfiguration): Observable<any> {
    return this.http.put(this.callsConfigurationUrl, callsConfiguration);
  }

}
